import React from 'react'
import { formatPrice, formatPercent } from '@@partner:helpers/util'

import './OrderTotalInfo.scss'

export interface OrderTotalInfoProps {
  total: number
  showPercent?: boolean
  showTotal?: boolean
  saleInfo?: {
    sale?: number
  }
  totalCashback?: number
}

export default function OrderTotalInfo ({
  total = 0,
  showPercent = false,
  showTotal = false,
  saleInfo
}: OrderTotalInfoProps) {
  const formattedTotal = formatPrice(total)
  const currentTotal = formatPrice(total - (saleInfo?.sale ?? 0))
  const percent = Math.floor(((saleInfo?.sale ?? 0) / total) * 100)

  const showSale = showTotal || showPercent

  return (
    <>
      {saleInfo?.sale ? (
        <>
          <span className="OrderTotalInfo__OldPrice">{formattedTotal}</span>
          <span className="OrderTotalInfo__Price">{currentTotal}</span>
          {showSale && (
            <span className="OrderTotalInfo__Sale">
              (
              {showTotal && (
                <span className="OrderTotalInfo__SaleTotal">
                  -{formatPrice(saleInfo.sale)}
                </span>
              )}
              {showPercent && (
                <span className="OrderTotalInfo__SalePercent">
                  -{formatPercent(percent)}
                </span>
              )}
              )
            </span>
          )}
        </>
      ) : (
        <span className="OrderTotalInfo__Price">{formattedTotal}</span>
      )}
    </>
  )
}
